<template>
  <div class="category-select-wrapper">
    <p class="category-title">
      <van-icon name="bars" size="20" />
      <span class="title-text">Category</span>
      <van-icon name="play" size="16" class="jt" />
    </p>
    <div class="base-category-list" @mouseleave="actCategoryIdx = -1">
      <div class="base-inner-list">
        <van-cell
          v-for="(item, idx) in categoryList"
          :key="item.id"
          @mouseenter="handleCategoryClick(item.id, idx)"
          @click="handleCategorySubClick(item)"
        >
          <template #title>
            <div :class="actCategoryIdx === idx ? `base-category-item base-category-item-act` : 'base-category-item'">
              <img class="cty-icon" :src="$cvWebpFn(item.iconUrl || '', { w: 30 })">
              <p class="category-name">{{ item.name }}</p>
              <van-icon name="arrow" size="13" color="#999" />
            </div>
          </template>
        </van-cell>
      </div>
    
      <div class="sub-category-plan">
        <div
          v-for="item in categoryList[actCategoryIdx]?.children || []" 
          :key="item.id"
          class="category-child"
        >
          <van-cell :title="item.name" is-link @click="handleCategorySubClick(item)" />
          <div class="last-category-list">
            <div 
              v-for="sub in item.children || []"
              :key="sub.id"
              class="last-category-item"
              @click="handleCategorySubClick(sub)"
            >
              <div class="inner">
                <div class="cty-img">
                  <img v-lazy="$cvWebpFn(sub.iconUrl ? sub.iconUrl: '', { w: 70 })" :alt="sub.name">
                </div>
                <p class="category-name">{{ sub.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getFrontCtgs } from '@/api/models/home'
import { buildCategoryNavigationSource, jumpCategoryBindUrl } from '~/plugins/utils'

const categoryList = useRecommendCategory()
const actCategoryIdx = ref<number>(-1)
const router = useRouter()
const route = useRoute()
const { $formatStringToURL } = useNuxtApp()

onMounted(async() => {
  const allFrontCtg = await getFrontCtgs()
  
  if(allFrontCtg?.length > 0) {
    categoryList.value = allFrontCtg
  }
})

if(process.server) {
  try {
    // 取服务端缓存，再服务端提前将一级类目优先展示
    categoryList.value = useGlobalJsonData().value.front_categories?.data || []
  } catch(e) {
    console.error('-----homeRecommendCtgCache----', e)
  }
}

const handleCategoryClick = (id: number, index: number) => {
  actCategoryIdx.value = index
}

const handleCategorySubClick = (sub: ICategory) => {
  if(sub.bindUrl) {
    jumpCategoryBindUrl(sub.bindUrl, 'allCategory', sub.name, route)
  } else {
    // router.push(`/search?id=${sub.id}&form=category&ctgName=${sub.name}`)
    const source = buildCategoryNavigationSource('allCategory', sub.name)
    router.push(`/category/${$formatStringToURL(sub.name)}?id=${sub.id}&form=category&source=${encodeURIComponent(source)}`)
  }
}
</script>

<style lang="scss" scoped>
.category-select-wrapper{
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .base-inner-list{
    height: 944px;
    overflow: auto;
    @include pc__scrollbar(10px, 8px);
    &::-webkit-scrollbar {
      display: none;
    }
    &:hover {
      &::-webkit-scrollbar {
        display: block;
      }
    }
  }
  // @media (max-width: 1800px) { 
  //   .base-inner-list {
  //     height: 688px;
  //   }
  // }
  .base-inner-list:deep(.van-cell) {
    cursor: pointer;
  }
}
$ctgTitleHeight: 80px;
.category-title{
  padding: 0 30px;
  height: $ctgTitleHeight;
  font-size: 32px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #fff;
  background-color: var(--pc-default-color);
  .title-text{
    margin: 0 20px;
  }
  .jt{
    transform:rotateZ(90deg);
  }
}
.base-category-list:deep(.van-cell) {
  padding: 0 20px;
}
.base-category-list{
  position: relative;
  z-index: 111;
  max-width: 500px;
  .base-category-item{
    height: 72.5px;
    font-size: 28px;
    font-weight: 500;
    display: flex;
    transition: all .15s;
    align-items: center;
    .category-name{
      flex: 1;
      @include ellipsis();
    }
    .cty-icon{
      margin-right: 10px;
      min-width: 50px;
      height: 50px;
      object-fit: contain;
    }
  }
  .base-category-item-act {
    font-weight: 600;
    color: var(--pc-default-color);
  }
}
.sub-category-plan{
  overflow: auto;
  padding-bottom: 30px;
  height: 0;
  width: 0;
  position: absolute;
  left: 100%;
  top: 0;
  box-shadow: 0 0 8px #cacaca;
  border-radius: 6px;
  transition: all .15s;
  @include pc__scrollbar(10px, 10px);
  background-color: #fff;
  &:deep(.van-cell){
    height: 80px;
    align-items: center;
    font-weight: 600;
    font-size: 30px;
    margin: 20px 0;
  }
  .last-category-list{
    display: flex;
    flex-wrap: wrap;
    padding: 0 20px;
    .last-category-item{
      width: 10%;
      box-sizing: border-box;
      padding: 10px;
      cursor: pointer;
      .inner{
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: all .15s;
        &:hover{
          transform: scale(1.15);
          color: var(--pc-default-color);
          text-shadow: 0 0 1px var(--pc-default-color);
        }
        .cty-img{
          width: 140px;
          height: 140px;
        }
        img{
          width: 140px;
          height: 140px;
          object-fit: contain;
        }
        .category-name{
          margin-top: 10px;
          font-size: 26px;
          text-align: center;
          @include ellipsisMultiline(2);
        }
      }
    }
  }
}

.base-category-list:hover{
  .sub-category-plan{
    width: calc(var(--viewport-width) - 100%);
    height: 70vh;
    display: block;
  }
}
@media (max-width: 1800px) { 
  .base-category-list:hover .sub-category-plan{
    width: calc(1880px - 100%);
  }
  .sub-category-plan .last-category-list .last-category-item {
    width: 13%;
  }
}

</style>
